import { deviceDetect } from 'react-device-detect'

const CoreEnums = {
  localStorage: {
    IS_DARK_THEME: 'isDarkTheme',
    THEME_TOKEN: 'themeToken'
  },
  userRoles: {
    SUPERADMIN: 'super_admin',
    ADMIN: 'admin',
    SUBSCRIPTION_ADMIN: 'subscription_admin',
    MEDICAL_PROFESSIONAL: 'medical_professional',
    PATIENT: 'patient',
    RECEPTION: 'reception'
  },
  userProfessions: {
    NURSE: 'nurse',
    DOCTOR: 'doctor'
  },
  menuActions: {
    LEFT: 'left',
    RIGHT: 'right'
  },
  tabActions: {
    CHANGE: 'change',
    CLOSE: 'close'
  },
  menuTitles: {
    LEFT_MENU: 'Portal Menu',
    RIGHT_MENU: 'Administration'
  },
  errorMessages: {
    ENTITY_NOT_AUTH: 'You are not authorized to access this entity',
    UNKNOWN_ERROR: 'An unknown error has occurred. Please try again later.'
  },
  tabKeys: {
    SEARCH_ENGINE: 'searchEngine',
    META_SERVICES: 'metaServices',
    // Patient
    PAT_PATIENT_PROFILE: 'patPatientProfile',
    PAT_MACRO_TRACKER: 'patMacroTracker',
    PAT_APPOINTMENTS: 'patAppointments',
    PAT_MEDICAL_HISTORY: 'patMedicalHistory',
    PAT_HEALTH_STATS: 'patHealthStats',
    PAT_MEDICATIONS: 'MEDICATIONS',
    PAT_VIRTUAL_CONSULT_SESSION: 'patVirtualConsultSession',
    PAT_CARE_SYNC: 'patCareSync',
    PAT_CARE_SYNC_PROD: 'patCareSyncProd',
    CHAD_DASHBOARD: 'CHAD_DASHBOARD',
    CHAD_LEADERBOARD: 'CHAD_LEADERBOARD',

    // Schedule
    SCHEDULE_CLINIC_VISIT: 'scheduleClinicVisit',
    SCHEDULE_VIRTUAL_VISIT: 'scheduleVirtualVisit',

    // PROTOTYPE

    APPOINTMENTS_CALENDAR: 'appointmentsCalendar',

    // DATAPOINTS
    DATA_POINTS_STANDARD: 'dataPointStandard',
    DATA_POINTS_GENERAL: 'dataPointsGeneral',
    DATA_POINTS_VITALS: 'dataPointsVitals',
    DATA_POINTS_RAPID: 'dataPointsRapid',
    DATA_POINTS_LAB: 'dataPointsLab',
    DATA_POINTS_POC: 'dataPointPoc',

    DATA_POINT_TEMPLATES: 'dataPointTemplates',
    CLINICAL_REPORTING_TEMPLATES: 'clinicalReportingTemplates',
    CARE_PLANS: 'carePlans',
    MONITORING_PLANS: 'monitoringPlans',
    TREATMENT_PLANS: 'treatment_plans',
    PREVENTATIVE_PLANS: 'preventative_care_plans',
    REHABILITATION_PLANS: 'rehabilitation_plans',
    WELLNESS_PLANS: 'wellness_plans',
    MEAL_PLANS: 'meal_plans',
    HEALTH_PLANS: 'health_plans',

    HOME: 'home',
    ENTITIES: 'entities',
    ANALYTICS: 'analytics',
    CLINICAL_ANALYTICS: 'clinicalAnalytics',
    MANAGEMENT: 'management',
    PATIENT_BILLING: 'patientBilling',

    //Admin
    ADMIN_SUBSCRIPTIONS: 'admin_subscriptions',
    CLINIC_MANAGEMENT: 'clinicManagement',
    USER_MANAGEMENT: 'userManagement',
    SETTINGS: 'settings',
    CLINICS: 'clinics',
    SYSTEM_USERS: 'systemUsers',
    MEDICAL_PROFESSIONALS: 'medicalProfessionals',
    SERVICES: 'services',
    VIRTUAL_SERVICES: 'virtualServices',
    PATIENTS: 'patients',
    CONFIG: 'config',
    BOOKINGS: 'bookings',
    SCRIPTING: 'scripting',
    EXAMINATION_TEMPLATES: 'examinationTemplates',
    CARE_SYNC: 'careSync',
    CARE_SYNC_LAB_TESTS: 'careSyncLabTests',
    BILLING_PROFILE: 'billingProfile',

    // User
    AIMealTracker: 'AI Meal Tracker',
    MY_BOOKINGS: 'myBookings',
    MY_APPOINTMENTS: 'myAppointments',
    DIAGNOSIS_HISTORY: 'diagnosisHistory',
    MY_PROFILE: 'myProfile',
    PERSONAL_DETAILS: 'personalDetails',
    SUBSCRIPTIONS: 'subscriptions',
    MEDICAL_HISTORY: 'medicalHistory',
    NEW_MEDICAL_HISTORY: 'newMedicalHistory',
    MY_PATIENT_FILE: 'myPatientFile',
    SIGN_OUT: 'signOut',
    HEALTH_TRACKING_ENTRIES: 'healthTrackingEntries',
    VITAL_LINK: 'vitalLink',
    MY_HEALTH: 'myHealth',

    // Reception
    BILLING: 'billing',
    SCHEDULE_APPOINTMENT: 'schedule_appointment',
    INVOICES: 'invoices',
    PATIENT_PAYMENTS: 'patient_payments',
    PAYMENT_REMITTANCE: 'payment_remittance',
    REMITTANCES: 'remittances',
    DASHBOARD_BILLING: 'dashboard',
    BILLING_REPORTS: 'billing_reports',
    PATIENT_ACCOUNTS: 'patient_accounts',

    // Terms and Conditions
    TERMS_AND_CONDITIONS: 'termsAndConditions',

    // Medical Professional
    AVAILABILITY: 'availability',

    // Dependents
    DEPENDANTS: 'dependants',

    // Inventory Management
    INVENTORY_MANAGEMENT: 'inventory_management',
    INVENTORY_DASHBOARD: 'inventory_dashboard',
    INVENTORY_ITEMS: 'inventory_items',
    PURCHASE_ORDERS: 'purchase_orders',
    INVENTORY_REPORTS: 'inventory_reports',

    // Hospital Management
    HOSPITAL_MANAGEMENT: 'hospital_management',
    HOSPITAL_DASHBOARD: 'hospital_dashboard',
    ADMISSIONS: 'admissions',
    BED_MANAGEMENT: 'bed_management',
    PATIENT_CARE_TASKS: 'patient_care_tasks',
    CAREGIVER_ACTIVITIES: 'caregiver_activities',
    STAFF_REMINDERS: 'staff_reminders',
    THEATRE_DASHBOARD: 'theatre_dashboard',
    DISCHARGE_INSTRUCTIONS: 'discharge_instructions',
    SURGERY_LIST: 'surgery_list',
    THEATRE_ROOM_EVENTS: 'theatre_room_events',

    // Lab Orders
    LAB_ORDERS: 'labOrders',

    // SUPER ADMIN
    GLOBAL_SERVICES: 'global_services'
  },
  tabTitles: {
    SEARCH_ENGINE: 'Search Engine',
    META_SERVICES: 'Meta Services',
    // Schedule
    SCHEDULE_CLINIC_VISIT: 'Book Clinic',
    SCHEDULE_VIRTUAL_VISIT: 'Book Virtual',
    PAT_PATIENT_PROFILE: 'Patient Profile',
    PAT_VIRTUAL_CONSULT_SESSION: 'IN-CALL',
    CHAD_DASHBOARD: 'Become a champion',
    CHAD_LEADERBOARD: "Chad's Champions",

    // PROTOTYPE
    APPOINTMENTS_CALENDAR: 'Calendar',

    // DATA POINTS
    DATA_POINTS_GENERAL: 'DP General',
    DATA_POINTS_VITALS: 'DP Vitals',
    DATA_POINTS_RAPID: 'DP Rapid',
    DATA_POINTS_LAB: 'DP Lab',
    DATA_POINTS_POC: 'DP POC',
    DATA_POINTS_STANDARD: 'DP Standard',

    DATA_POINT_TEMPLATES: 'Examination Templates',
    CLINICAL_REPORTING_TEMPLATES: 'Clinical Report Templates',
    CARE_PLANS: 'Chronic Care Plans',
    MONITORING_PLANS: 'Monitoring Plans',
    TREATMENT_PLANS: 'Treatment Plans',
    PREVENTATIVE_PLANS: 'Preventative Plans',
    REHABILITATION_PLANS: 'Rehabilitation Plans',
    WELLNESS_PLANS: 'Wellness Plans',
    MEAL_PLANS: 'Meal Plans',
    HEALTH_PLANS: 'Health Plans',

    HOME: 'Home',
    ENTITIES: 'Entities',
    ANALYTICS: 'Analytics',
    CLINICAL_ANALYTICS: 'Clinical Analytics',
    MANAGEMENT: 'Management',
    PATIENT_BILLING: 'Patient Billing',

    //Admin
    ADMIN_SUBSCRIPTIONS: 'Meta-Link',
    CLINIC_MANAGEMENT: 'Manage Facilities',
    USER_MANAGEMENT: 'User Management',
    SETTINGS: 'Settings',
    CLINICS: 'Facilities',
    SYSTEM_USERS: 'System Users',
    MEDICAL_PROFESSIONALS: 'Medical Professionals',
    SERVICES: 'Services',
    VIRTUAL_SERVICES: 'Virtual Services',
    PATIENTS: 'Patients',
    CONFIG: 'Configure',
    BOOKINGS: 'Bookings',
    SCRIPTING: 'Scripts',
    EXAMINATION_TEMPLATES: 'Examination Templates',
    CARE_SYNC: 'Care Sync',
    CARE_SYNC_LAB_TESTS: 'Lab Tests',
    BILLING_PROFILE: 'Billing Profile',

    // User
    MY_BOOKINGS: 'Appointments',
    MY_APPOINTMENTS: 'My Appointments',
    DIAGNOSIS_HISTORY: 'Diagnosis History',
    PERSONAL_DETAILS: 'Personal Details',
    MY_PROFILE: 'My Profile',
    SUBSCRIPTIONS: 'Subscriptions',
    MEDICAL_HISTORY: 'Medical History',
    NEW_MEDICAL_HISTORY: 'Medical History',
    MY_PATIENT_FILE: 'My Patient File',
    SIGN_OUT: 'Sign Out',
    HEALTH_TRACKING_ENTRIES: 'Health Tracking',
    VITAL_LINK: 'Meta-Link (SOS)',
    MY_HEALTH: 'My Health',

    // Reception
    BILLING: "Today's Billing",
    SCHEDULE_APPOINTMENT: 'Schedule Appointment',
    INVOICES: 'Invoices',
    PATIENT_PAYMENTS: 'Patient Payments',
    PAYMENT_REMITTANCE: 'Payment Remittance',
    REMITTANCES: 'Remittances',
    DASHBOARD_BILLING: 'Dashboard',
    BILLING_REPORTS: 'Reports',
    PATIENT_ACCOUNTS: 'Patient Accounts',

    // Medical Professional
    AVAILABILITY: 'Availability',

    // Terms and Conditions
    TERMS_AND_CONDITIONS: 'Terms and Conditions',

    // Dependents
    DEPENDANTS: 'Family Accounts',
    // Patient
    PAT_MACRO_TRACKER: 'Macro Tracker',
    PAT_APPOINTMENTS: 'Appointments',
    PAT_MEDICAL_HISTORY: 'Medical History',
    PAT_HEALTH_STATS: 'Health Stats',
    PAT_MEDICATIONS: 'Medications',
    PAT_CARE_SYNC: 'Care Sync',
    PAT_CARE_SYNC_PROD: 'Care Sync Prod',

    // Inventory Management
    INVENTORY_MANAGEMENT: 'Inventory Management',
    INVENTORY_DASHBOARD: 'Inventory Dashboard',
    INVENTORY_ITEMS: 'Inventory Items',
    PURCHASE_ORDERS: 'Purchase Orders',
    INVENTORY_REPORTS: 'Inventory Reports',

    // Hospital Management
    HOSPITAL_MANAGEMENT: 'Hospital Management',
    HOSPITAL_DASHBOARD: 'Hospital Dashboard',
    ADMISSIONS: 'Admissions',
    BED_MANAGEMENT: 'Bed Management',
    PATIENT_CARE_TASKS: 'Patient Care Tasks',
    CAREGIVER_ACTIVITIES: 'Caregiver Activities',
    STAFF_REMINDERS: 'Staff Reminders',
    THEATRE_DASHBOARD: 'Theatre Dashboard',
    DISCHARGE_INSTRUCTIONS: 'Discharge Instructions',
    SURGERY_LIST: 'Surgery List',
    THEATRE_ROOM_EVENTS: 'Theatre Room Events',

    // Lab Orders
    LAB_ORDERS: 'Lab Orders',

    // SUPER ADMIN
    GLOBAL_SERVICES: 'Global Services'
  },
  bookingStatuses: {
    checkin: 'check_in',
    screening: 'screening',
    consultation: 'consultation',
    reception: 'reception',
    completed: 'completed',
    cancelled: 'cancelled'
  },
  provinces: {
    eastern_cape: 'Eastern Cape',
    free_state: 'Free State',
    gauteng: 'Gauteng',
    kwazulu_natal: 'KwaZulu-Natal',
    limpopo: 'Limpopo',
    mpumalanga: 'Mpumalanga',
    northern_cape: 'Northern Cape',
    north_west: 'North West',
    western_cape: 'Western Cape'
  },
  menuColors: {
    SEARCH_ENGINE: '#1890ff',
    META_SERVICES: '#1890ff',
    // Patient
    PAT_APPOINTMENTS: '#1890ff',
    PAT_MEDICAL_HISTORY: '#1890ff',
    PAT_HEALTH_STATS: '#1890ff',
    PAT_MEDICATIONS: '#1890ff',
    PAT_PATIENT_PROFILE: '#1890ff',
    PAT_MACRO_TRACKER: '#1890ff',
    PAT_VIRTUAL_CONSULT_SESSION: '#1890ff',
    PAT_CARE_SYNC: '#1890ff',
    PAT_CARE_SYNC_PROD: '#1890ff',
    CHAD_DASHBOARD: '#1890ff',
    CHAD_LEADERBOARD: '#1890ff',

    // Inventory Management
    INVENTORY_MANAGEMENT: '#1890ff',
    INVENTORY_DASHBOARD: '#1890ff',
    INVENTORY_ITEMS: '#1890ff',
    PURCHASE_ORDERS: '#1890ff',
    INVENTORY_REPORTS: '#1890ff',

    // Scheduling
    SCHEDULE_CLINIC_VISIT: '#1890ff',
    SCHEDULE_VIRTUAL_VISIT: '#1890ff',

    // PROTOTYPE
    APPOINTMENTS_CALENDAR: '#1890ff',

    // DATAPOINTS
    DATA_POINTS_STANDARD: '#1890ff',
    DATA_POINTS_GENERAL: '#1890ff',
    DATA_POINTS_VITALS: '#1890ff',
    DATA_POINTS_RAPID: '#1890ff',
    DATA_POINTS_LAB: '#1890ff',
    DATA_POINTS_POC: '#1890ff',

    DATA_POINT_TEMPLATES: '#1890ff',
    CLINICAL_REPORTING_TEMPLATES: '#1890ff',
    CARE_PLANS: '#1890ff',
    MONITORING_PLANS: '#1890ff',
    TREATMENT_PLANS: '#1890ff',
    PREVENTATIVE_PLANS: '#1890ff',
    REHABILITATION_PLANS: '#1890ff',
    WELLNESS_PLANS: '#1890ff',
    MEAL_PLANS: '#1890ff',
    HEALTH_PLANS: '#1890ff',

    HOME: '#1890ff',
    ENTITIES: '#1890ff',
    ANALYTICS: '#1890ff',
    CLINICAL_ANALYTICS: '#1890ff',
    MANAGEMENT: '#1890ff',

    // Admin
    ADMIN_SUBSCRIPTIONS: '#1890ff',
    VIRTUAL_SERVICES: '#1890ff',
    SCRIPTING: '#1890ff',
    EXAMINATION_TEMPLATES: '#1890ff',
    CARE_SYNC: '#1890ff',
    CARE_SYNC_LAB_TESTS: '#1890ff',

    // Clinic Management
    CLINIC_MANAGEMENT: '#1890ff',
    CLINICS: '#1890ff',
    SERVICES: '#1890ff',
    BOOKINGS: '#1890ff',
    AVAILABILITY: '#1890ff',

    // User Management
    USER_MANAGEMENT: '#1890ff',
    SYSTEM_USERS: '#1890ff',
    MEDICAL_PROFESSIONALS: '#1890ff',
    PATIENTS: '#1890ff',

    // Settings
    SETTINGS: '#1890ff',
    CONFIG: '#1890ff',
    TERMS_AND_CONDITIONS: '#1890ff',

    // User
    AIMealTracker: '#1890ff',
    MY_BOOKINGS: '#1890ff',
    MY_APPOINTMENTS: '#1890ff',
    DIAGNOSIS_HISTORY: '#1890ff',
    MY_PROFILE: '#1890ff',
    PERSONAL_DETAILS: '#1890ff',
    SUBSCRIPTIONS: '#1890ff',
    MEDICAL_HISTORY: '#1890ff',
    NEW_MEDICAL_HISTORY: '#1890ff',
    MY_PATIENT_FILE: '#1890ff',
    SIGN_OUT: '#1890ff',
    HEALTH_TRACKING_ENTRIES: '#1890ff',
    VITAL_LINK: '#1890ff',
    MY_HEALTH: '#1890ff',

    // Reception
    DASHBOARD_BILLING: '#1890ff',
    BILLING: '#1890ff',
    SCHEDULE_APPOINTMENT: '#1890ff',
    INVOICES: '#1890ff',
    REMITTANCES: '#1890ff',
    PATIENT_PAYMENTS: '#1890ff',
    BILLING_REPORTS: '#1890ff',
    BILLING_PROFILE: '#1890ff',
    PATIENT_ACCOUNTS: '#1890ff',
    // Dependents
    DEPENDANTS: '#1890ff',

    PEACH_PAYMENTS_TEMPORARY: '#1890ff',

    // Hospital Management
    HOSPITAL_MANAGEMENT: '#1890ff',
    HOSPITAL_DASHBOARD: '#1890ff',
    ADMISSIONS: '#1890ff',
    BED_MANAGEMENT: '#1890ff',
    PATIENT_CARE_TASKS: '#1890ff',
    CAREGIVER_ACTIVITIES: '#1890ff',
    STAFF_REMINDERS: '#1890ff',
    THEATRE_DASHBOARD: '#1890ff',
    DISCHARGE_INSTRUCTIONS: '#1890ff',
    SURGERY_LIST: '#1890ff',
    THEATRE_ROOM_EVENTS: '#1890ff',

    // Lab Orders
    LAB_ORDERS: '#1890ff',

    // SUPER ADMIN
    GLOBAL_SERVICES: '#1890ff'
  }
}

export default CoreEnums
